<template>
  <div class="organization">
    <xdf-products></xdf-products>
    <xdf-invest></xdf-invest>
  </div>
</template>

<script>
import XdfProducts from './XdfProducts'
import XdfInvest from './XdfInvest'
export default {
  name: 'Organization',
  components: {
    XdfProducts,
    XdfInvest
  }
}
</script>

<style lang="stylus" scoped>
.organization
  padding-top: 18px
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Organization.vue